export const authStoreKey = 'auth';
